import * as React from "react";

import type { TabListProps } from "./TabList.types";
import { TabListFocusController } from "./TabListFocusController";

import { TabList } from "./TabList";
import { getWrapperStyles } from "./TabListFocusWrapperStyles";

export class TabListWithFocusWrapper extends React.PureComponent<
  TabListProps & React.ForwardedRef<HTMLDivElement>,
  {}
> {
  private tabsterZone = React.createRef<HTMLDivElement>();
  private tabListRef = React.createRef<HTMLDivElement>();
  private tabListFocusRef: React.RefObject<{ focus: () => void }> =
    React.createRef();
  private tabListInnerFocusRef: React.RefObject<{ focus: () => void }> =
    React.createRef();

  public render() {
    return (
      <TabListFocusController
        ref={this.tabsterZone}
        className={getWrapperStyles()}
        firstFocusableRef={this.tabListFocusRef}
      >
        <TabList
          ref={this.tabListRef}
          focusTabListRef={this.tabListInnerFocusRef}
          {...this.props}
        />
      </TabListFocusController>
    );
  }

  // We manually control some aspects of keyboard focus like the
  // tab loop and switching tabs on key down so we need to manually
  // notify the components of focus events
  public focus() {
    this.tabListFocusRef.current?.focus();
    this.tabListInnerFocusRef.current?.focus();
  }
}
